class Modal {
    constructor() {
        this.activeModal = null;

        this.onOpen = () => { };
        this.onClose = () => { };

        this.init();
    }

    init() {
        document.querySelectorAll('[data-modal-target]').forEach(button => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('data-modal-target');
                const modal = document.querySelector(`[data-modal="${targetId}"]`);
                if (modal) this.open(modal);
            });
        });

        document.querySelectorAll('[data-modal-close]').forEach(button => {
            button.addEventListener('click', () => {
                const modal = button.closest('[data-modal]');
                if (modal) this.close(modal);
            });
        });

        document.addEventListener('click', (event) => {
            const modal = this.activeModal;
            if (!modal) return;

            const content = modal.querySelector('[data-modal-content]');
            const clickedOutside = !content.contains(event.target) && modal.contains(event.target);
            if (clickedOutside) this.close(modal);
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.activeModal) {
                this.close(this.activeModal);
            }
        });
    }

    open(modal) {
        modal.classList.add('is-active');
        document.body.classList.add('modal-open', 'block-scroll');
        this.activeModal = modal;

        if (typeof this.onOpen === 'function') {
            this.onOpen(modal);
        }
    }

    close(modal) {
        modal.classList.remove('is-active');
        document.body.classList.remove('modal-open', 'block-scroll');

        if (typeof this.onClose === 'function') {
            this.onClose(modal);
        }

        if (this.activeModal === modal) this.activeModal = null;
    }
}

export default new Modal();
